
import {Component, Prop, Vue} from "vue-property-decorator";
import {PostService} from "@/services/PostService";
import SuggestForm from "@/components/SuggestForm.vue";
import {BButton} from 'buefy/dist/esm/button'
import {BModal} from 'buefy/dist/esm/modal'
import {isSupported} from "firebase/messaging"

@Component({
  components: {SuggestForm, 'b-button': BButton, 'b-modal': BModal}
})
export default class HelloWorld extends Vue {
  formOpened = false
  canSuggest = PostService.Instance.canSuggest()
  needSubscribe = false
  
  async mounted(){
    this.needSubscribe = !PostService.Instance.isSubscribed() && await isSupported()
  }

  async subscribe() {
    await PostService.Instance.subscribe()
  }

  openForm() {
    this.formOpened = true
  }

  closeForm() {
    this.canSuggest = false
    this.formOpened = false
  }
}
